import { render } from "./TaskSettingsHeader.vue?vue&type=template&id=1d0451dc"
import script from "./TaskSettingsHeader.vue?vue&type=script&lang=js"
export * from "./TaskSettingsHeader.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./TaskSettingsHeader.vue?vue&type=style&index=0&id=1d0451dc&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__